export function capitalizeFirstLetter(string) {
  // Check if the input string is empty or null
  if (!string) {
    return '' // If empty or null, return an empty string
  }

  // Capitalize the first letter of the input string and concatenate the rest of the string
  return string.charAt(0).toUpperCase() + string.slice(1)
}
